const PER_PAGE = 8

export class UsedCarsArchive {
  constructor() {
    this.blocks = document.querySelectorAll('.s-used-cars-archive')
    this.blocks.forEach((block) => this.initBlock(block))
  }

  initBlock(block) {
    const list = block.querySelector('.s-used-cars-archive-list')
    const items = block.querySelectorAll('.s-used-cars-archive-item')
    const moreBtn = block.querySelector('.s-used-cars-archive-more')

    if (!list || !items.length || !moreBtn) return

    let visibleCount = PER_PAGE

    const updateVisibility = () => {
      items.forEach((item, index) => {
        if (index < visibleCount) {
          item.classList.remove('is-hidden')
        } else {
          item.classList.add('is-hidden')
        }
      })
      if (visibleCount >= items.length) {
        moreBtn.classList.add('is-hidden')
      }
    }

    moreBtn.addEventListener('click', () => {
      visibleCount += PER_PAGE
      updateVisibility()
    })

    updateVisibility()
  }
}
